export default "__VITE_ASSET__DkEDfTJR__"